module.exports = __webpack_public_path__ + "static/media/carouselimg1.6894657e.png";